<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data: ()=> ({
    loginTime: null,
    test: null
  }),
  mounted(){
    this.test = setInterval(this.loginTimer, 3000)
  },
  computed: mapGetters(['locale']),
  methods:{
    async loginTimer(){
      if(localStorage.weltumTimeAuth){
        this.loginTime = +localStorage.weltumTimeAuth + +localStorage.weltumtokenTimeAlive
        if(+this.loginTime < +Date.now()){
            await this.$store.dispatch('logout') 
            this.$router.push( { name: 'Login' } )
            this.$toastLocalized("sessionTerminated")
        }
      }
    }
  }

}
</script>
<style lang="scss">
  @import 'node_modules/bootstrap/scss/bootstrap';
  @import 'node_modules/bootstrap-vue/src/index.scss';
  .btn-outline-danger {
    color: #dc1b23;
    border-color: #dc1b23;
  }
  .btn-outline-danger:hover, .btn-danger {
    background-color: #dc1b23;
  }
</style>
